import {
  CategoriesHeroItem,
  CategoriesHeroProps,
} from "../../../ui/organisms/CategoriesHero"
import { toLinkField } from "./link"

const toCategoriesHeroItem = (item: any): CategoriesHeroItem => ({
  image: item.image,
  label: item.label,
  link: toLinkField(item.link),
  colSpan: item.colSpan,
  visibility: item.visibility,
})

export const toCategoriesHeroProps = (item: any): CategoriesHeroProps => {
  return {
    caption: item.data?.contents?.caption,
    title: item.data?.contents?.title,
    styles: {
      textColor: item.data?.styles?.textColor?.hex,
      backgroundColor: item.data?.styles?.backgroundColor?.hex,
      backgroundImage: item.data?.styles?.backgroundImage,
      backgroundImageMobile: item.data?.styles?.backgroundImageMobile,
      backgroundParallax: item.data?.styles?.backgroundParallax,
      itemsPerRow: item.data?.styles?.itemsPerRow,
      itemsPerRowMobile: item.data?.styles?.itemsPerRowMobile,
    },
    items: item.data?.contents?.items?.map(toCategoriesHeroItem),
  }
}
